import React, { Component } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { CallAPI, GetCookieFunction, HandleTextChange, HandleSelectChange, CapitalizeWord } from '../../utils/util';
import EditIcon from "../../resources/images/icon_edit.png";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let params = useParams();
        let [searchParams] = useSearchParams();
        return <Component {...props} router={{ location, params, searchParams }} />;
    }
    return ComponentWithRouterProp;
}

class StaffLookup extends Component {
    constructor(props) {
        super(props);
        this.isExecutive = GetCookieFunction("User").type === "executive";
        this.state = {
            rows: [],
            pFName: "",
            pLName: "",
            searchCenterID: GetCookieFunction("Center").id,
            centers: []
        };
        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
    }

    componentDidMount() {
        if (this.isExecutive) {
            CallAPI({}, "centers/list", 'GET', (res) => {
                this.setState({ centers: res || [] }, this.fetchStaff);
            });
        } else {
            this.fetchStaff();
        }
    }

    fetchStaff = () => {
        const centerId = this.isExecutive ? this.state.searchCenterID : GetCookieFunction("Center").id;
        const includeExec = this.isExecutive ? 1 : 0;
        const fname = encodeURIComponent(this.state.pFName || "");
        const lname = encodeURIComponent(this.state.pLName || "");
        CallAPI({}, `users/staff?fname=${fname}&lname=${lname}&centerid=${centerId}&includeexec=${includeExec}`, 'GET', (res) => {
            this.setState({ rows: res || [] });
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.fetchStaff();
    };

    render = () => {
        const { rows } = this.state;

        return (
            <div className="lookup-page">
                <div className="lookup-filter-bar">
                    <form className="lookup-filter-form" onSubmit={this.handleSubmit}>
                        <div className="lookup-filter-fields">
                            <div className="lookup-field">
                                <label htmlFor="pFName">First Name</label>
                                <input type="text" id="pFName" name="pFName"
                                    onChange={(e) => this.handleTextChange(e)}
                                    placeholder="First name" />
                            </div>
                            <div className="lookup-field">
                                <label htmlFor="pLName">Last Name</label>
                                <input type="text" id="pLName" name="pLName"
                                    onChange={(e) => this.handleTextChange(e)}
                                    placeholder="Last name" />
                            </div>
                            {this.isExecutive && (
                                <div className="lookup-field">
                                    <label htmlFor="searchCenterID">Center</label>
                                    <select id="searchCenterID" name="searchCenterID"
                                        value={this.state.searchCenterID}
                                        onChange={(e) => this.handleSelectChange(e)}>
                                        <option value="0">All Centers</option>
                                        {this.state.centers.map(c => (
                                            <option key={c.centerID} value={c.centerID}>{c.centerName}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="lookup-field lookup-field-btn">
                                <button type="submit" className="logSubmit lookup-search-btn">Search</button>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="lookup-results">
                    <div className="lookup-results-header">
                        <span>Staff Members</span>
                        <span className="lookup-count">{rows.length} result{rows.length !== 1 ? 's' : ''}</span>
                    </div>
                    <div className="lookup-results-body">
                        {rows.length === 0
                            ? <div className="lookup-empty">No staff members found.</div>
                            : rows.map((user, i) => (
                                <div key={i} className="lookup-row">
                                    <div className="lookup-row-info">
                                        <strong>{user.firstName} {user.lastName}</strong>
                                        <span>{CapitalizeWord(user.userType)}{user.isAdmin ? " · Admin" : ""}{!user.isActive ? " · Inactive" : ""}</span>
                                        <span>{user.email || "No email"} · {user.phone}</span>
                                    </div>
                                    <div className="lookup-row-actions">
                                        <a href={`/admin/users/update?uid=${user.userId}`} className="action-btn" data-tooltip="Edit User" aria-label="Edit User">
                                            <img src={EditIcon} alt="Edit" />
                                        </a>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(StaffLookup);
